import {LOGIN, LOGOUT} from "../reducers/loginReducer";

export const loginAccount = () => {
    return {
        type: LOGIN
    }
};

export const logoutAccount = () => ({type: LOGOUT});
